import {
  AdditionalParamsRequest,
  ApiClient,
  ApiFetchClient,
  ApiTypes,
  RequestOptionsParameters,
} from '@ama-sdk/core';
import {
  createAmadeusGatewayTokenRequest,
} from '@dapi/amadeus-gateway-sdk';
import {
  AppBootstrapConfig,
  BotProtectionFactory,
} from '@refx/shared-common';
import {
  DeepLinkApiResponse,
} from '../../contracts';

export class BlueApiClient {

  private readonly apiClient: ApiClient;

  constructor(
    private readonly appBootstrapConfig: AppBootstrapConfig,
    botProtectionFactory: BotProtectionFactory
  ) {
    const botProtection = botProtectionFactory.getBotProtectionProviders(appBootstrapConfig);
    const gatewayPlugin = createAmadeusGatewayTokenRequest({
      gatewayUrl: appBootstrapConfig.gatewayBaseUrl + appBootstrapConfig.gatewayEndPoint,
      gatewayClientId: appBootstrapConfig.gatewayClientId,
      gatewayClientPrivate: appBootstrapConfig.gatewayClientSecret,
      customApiClientOptions: botProtection.length ? {
        requestPlugins: botProtection.length ? botProtection : []
      } : {}
    });

    this.apiClient = new ApiFetchClient({
      basePath: appBootstrapConfig.gatewayBaseUrl,
      requestPlugins: [
        gatewayPlugin,
        ...botProtection.length ? botProtection : [],
        new AdditionalParamsRequest({
          headers: {
            'Content-Type': 'application/json'
          }
        })
      ]
    });
  }


  public async call(body: string): Promise<DeepLinkApiResponse> {
    const basePathUrl = `${this.appBootstrapConfig.gatewayBaseUrl}/partnertravel/deeplinkbroker/deeplink`;
    const requestOptionsParams: RequestOptionsParameters = {
      basePath: basePathUrl,
      headers: {
        'Content-Type': 'application/json'
      },
      body: body,
      method: 'POST',
      api: {client: this.apiClient, apiName: 'BLUEAPI'}
    };
    const options = await this.apiClient.getRequestOptions(requestOptionsParams);
    const url = this.apiClient.prepareUrl(options.basePath, options.queryParams);
    const ret = this.apiClient.processCall<DeepLinkApiResponse>(url, options, ApiTypes.DEFAULT, 'BLUEAPI');
    return ret;
  }
}
